"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _momentTimezone = babelHelpers.interopRequireDefault(require("moment-timezone"));

var _promisePolyfill = require("promise-polyfill");

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _temp2;

var AddEventSettings = function () {
  try {
    return require('add-event-settings').default;
  } catch (e) {
    return null;
  }
}();

var AddEvent = new _promisePolyfill.DelayedPromise(function (resolve, reject) {
  if (AddEventSettings) {
    window.addeventasync = function () {
      addeventatc.settings(AddEventSettings);
      resolve(addeventatc);
    };

    var S = document.createElement('script');
    S.type = 'text/javascript';
    S.src = 'https://addevent.com/libs/atc/1.6.1/atc.min.js';
    S.async = true;
    S.defer = true;
    document.head.appendChild(S);
  } else {
    resolve(null);
  }
});
var buttonRefresh = false;

function refreshButtons() {
  clearTimeout(buttonRefresh);
  buttonRefresh = setTimeout(function () {
    var x = buttonRefresh;
    AddEvent.then(function (atc) {
      if (x == buttonRefresh) atc.refresh();
    });
  }, 0);
}

var AddEventButtonItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(AddEventButtonItem, _Component);

  function AddEventButtonItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, AddEventButtonItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(AddEventButtonItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "items", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(AddEventButtonItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        title: this.title,
        className: "addeventatc"
      }, this.title, Object.keys(this.items).filter(function (key) {
        return _this2.items[key];
      }).map(function (key) {
        return _react.default.createElement("span", {
          key: key,
          className: key
        }, _this2.items[key]);
      }));
    }
  }]);
  return AddEventButtonItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "items", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Add to Calendar';
  }
})), _class);
var AddEventButton = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(AddEventButton, _Component2);

  function AddEventButton() {
    var _babelHelpers$getProt2;

    var _this3;

    babelHelpers.classCallCheck(this, AddEventButton);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(AddEventButton)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "buttonTitle", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "start", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "end", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "title", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "link", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "password", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "timezone", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "shortUrl", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "allDay", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "uid", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    _this3.state = {
      atc: null
    };
    return _this3;
  }

  babelHelpers.createClass(AddEventButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      AddEvent.then(function (atc) {
        return _this4.setState({
          atc: atc
        });
      });
    }
  }, {
    key: "makeDescription",
    value: function makeDescription() {
      var d = [];

      if (this.link) {
        d.push('Event Link', this.link, '');

        if (this.password) {
          d.push('Event Password', this.password, '');
        }
      }

      if (this.shortUrl) d.push('For more information about this event, visit:', this.shortUrl);
      return d.join('\n');
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.atc) {
        return null;
      }

      return _react.default.createElement("div", {
        ref: refreshButtons,
        className: "add-event-button",
        dangerouslySetInnerHTML: {
          __html: _server.default.renderToStaticMarkup(_react.default.createElement(AddEventButtonItem, {
            title: this.buttonTitle,
            items: {
              start: _momentTimezone.default.tz(this.start, this.timezone).format('YYYY-MM-DDTHH:mm:ss'),
              end: _momentTimezone.default.tz(this.end, this.timezone).format('YYYY-MM-DDTHH:mm:ss'),
              title: this.title,
              description: this.makeDescription(),
              all_day_event: this.allDay ? 'true' : 'false',
              timezone: this.timezone,
              calname: 'use-title',
              uid: this.uid,
              client: (AddEventSettings || {}).license
            }
          }))
        }
      });
    }
  }]);
  return AddEventButton;
}(_react.Component), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "buttonTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "start", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "end", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "password", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "timezone", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "shortUrl", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "allDay", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "uid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = AddEventButton;